import { z, type ZodTypeAny } from 'zod';

export const SOURCE_VALUES = ['EDGE', 'CLOUD', 'PORTAL', 'KIOSK'] as const;

const SourceSchema = z.enum(SOURCE_VALUES);

export function SafeEventEnvelopeSchema<T extends ZodTypeAny>(payloadSchema: T) {
  return z.object({
    eventId: z.string().uuid(),
    eventType: z.string().min(1),
    version: z.literal('1.0'),
    timestamp: z.string().datetime(),
    deviceId: z.string().min(1),
    tenantId: z.string().min(1),
    designadorId: z.string().min(1),
    localId: z.string().min(1),
    safeId: z.string().min(1),
    nsu: z.string().min(1),
    source: SourceSchema,
    payload: payloadSchema,
    metadata: z.object({
      correlationId: z.string().uuid(),
      causationId: z.string().nullable(),
      schemaVersion: z.string().min(1),
      previousHash: z.string().nullable(),
      hash: z.string().min(1),
    }),
  });
}

export type SafeEventEnvelope<T = unknown> = {
  eventId: string;
  eventType: string;
  version: '1.0';
  timestamp: string;
  deviceId: string;
  tenantId: string;
  designadorId: string;
  localId: string;
  safeId: string;
  nsu: string;
  source: (typeof SOURCE_VALUES)[number];
  payload: T;
  metadata: {
    correlationId: string;
    causationId: string | null;
    schemaVersion: string;
    previousHash: string | null;
    hash: string;
  };
};
